module.exports = __webpack_public_path__ + "static/media/hospital4.f9ed6414.jpg";